import { render, staticRenderFns } from "./SimpleNameView.vue?vue&type=template&id=ba172536"
import script from "./SimpleNameView.vue?vue&type=script&lang=js"
export * from "./SimpleNameView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports